export const AppUrl = '//controller.inforder.eu/client_console/production/tasks/application.php'



// WEBPACK FOOTER //
// ./src/assets/js/variables.js